import axios from 'axios'
import qs from "qs"
import { clone, removeEmpty } from '@/util/libUtil.js'
import readError from '../util.js'


const state = () => ({
    isOpenDialog: false,
    isEditableForm: false,
    IsActive: false,
    formType: '',
    editingId: '',
    MaxNumber: 0,
    Name: '',
    SelectedPromotions: [],
    Operator: '',
    segment: '',
    Mobile_Line_Data: '',
    Data_Unit: '',
    Voice: '',
    Price: '',
    Upfront: '',
    additionalManagement: {
        additionals: [],
        totalEntries: 0,
        isLoading: false,
        page: 1,
        params: {},
        default: 0
    },
    isLoading: false,
    price_history: [],
    upfront_history: [],
    paths: {
        additionalsPath: '/api/servicios/adicionales/',
    }
})

const initialState = { ...state() }

const mutations = {
    resetStore: (state) => {
        let copy = [...state.additionals]
        initialState.additionals = copy
        Object.assign(state, initialState)
    },
    additionalManagementPage: (state, val) => {
        state.additionalManagement.page = val;
    },
    additionalManagementTarrifs: (state, val) => {
        state.additionalManagement.additionals = clone(val);
    },
    additionalManagementParams(state, val) {
        state.additionalManagement.params = val
    },
    additionalManagementIsLoading(state, val) {
        state.additionalManagement.isLoading = val
    },
    additionalManagement(state, val) {
        state.additionalManagement.totalEntries = val.count
        state.additionalManagement.additionals = val.results
    },
    price_history: (state, val) => {
        state.price_history = clone(val);
    },
    upfront_history: (state, val) => {
        state.upfront_history = clone(val);
    },
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    IsActive: (state, val) => {
        state.IsActive = val
    },
    Name: (state, val) => {
        state.Name = val
    },
    Operator: (state, val) => {
        state.Operator = val
    },
    Mobile_Line_Data: (state, val) => {
        state.Mobile_Line_Data = val
    },
    Data_Unit: (state, val) => {
        state.Data_Unit = val
    },
    Voice: (state, val) => {
        state.Voice = val
    },
    Price: (state, val) => {
        state.Price = val
    },
    Upfront: (state, val) => {
        state.Upfront = val
    },
    segment: (state, val) => {
        state.segment = val;
    },
    MaxNumber: (state, val) => {
        state.MaxNumber = val
    },
    SelectedPromotions: (state, val) => {
        state.SelectedPromotions = val
    },
    // additionals: (state, val) => {
    //     state.additionals = clone(val)
    // },
    isLoading: (state, val) => {
        state.isLoading = val
    }
}

const actions = {
    async updateAdditionalManagementParams({ commit, state }, params) {
        let newParams = { ...state.additionalManagement.params, ...params }
        newParams = removeEmpty(newParams) // eliminate nulls
        commit('additionalManagementParams', newParams)
    },
    async getAdditionals({ dispatch, getters, rootGetters, state, commit }) {
        try {
            commit('additionalManagementIsLoading', true)
            commit('ManagementBase/loadingItems', true, { root: true })
            let params = clone(state.additionalManagement.params);
            
            if(!'itemsPerPage' in params || !params['itemsPerPage']){
                params['itemsPerPage'] = rootGetters['ManagementBase/itemsPerPage']
            }

            let resp = await axios.get(getters.getEndpointFromPath(state.paths.additionalsPath), {
                params: params,
                paramsSerializer: params => {
                    return qs.stringify(params, { arrayFormat: 'brackets', skipNulls: true })
                },
            })
            commit('additionalManagement', resp.data)
            commit('additionalManagementIsLoading', false)
            commit('ManagementBase/loadingItems', false, { root: true })
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Adicionales cargadas correctamente'
            }, { root: true })
        } catch (error){
            let read = readError.readError(error)

            if('detail' in read && read.detail == 'Página inválida.'){
                dispatch('updateAdditionalManagementParams', { page: 1 })
                dispatch('getAdditionals')
            }else{            
                dispatch('util/showStatusSnackBar', {
                    statusType: 'error',
                    message: 'No se pudo cargar el contenido de Adicionales'
                }, { root: true })
            }
    }
    },
    async delete({ state, dispatch, getters }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.additionalsPath) + item.id + '/')
            dispatch('getAdditionals')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    async addAdditional({ state, getters, dispatch }) {
        let additional = {
            'max_number': state.MaxNumber,
            'name': state.Name,
            'promotions': state.SelectedPromotions,
            'operator': state.Operator,
            'segment': state.segment,
            'is_active': state.IsActive,
            'price_value': state.Price,
            mobile_line_info: {
                "price": {
                    "base_fee": parseFloat(state.Price).toFixed(4)
                },
                "mobile_line_data": {
                    "unit": state.Data_Unit,
                    "amount": state.Mobile_Line_Data
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": state.Voice
                }
            },
        }

        try {
            await axios.post(getters.getEndpointFromPath(state.paths.additionalsPath), additional)
            dispatch('getAdditionals')
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Adicional añadida correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al añadir adicional',
            }, { root: true })
        }
    },
    async editAdditional({ state, getters, dispatch }) {
        let additional = {
            'max_number': state.MaxNumber,
            'name': state.Name,
            'promotions': state.SelectedPromotions,
            'operator': state.Operator,
            'segment': state.segment,
            'is_active': state.IsActive,
            // 'price': state.price,
            mobile_line_info: {
                "price": {
                    "base_fee": parseFloat(state.Price).toFixed(4)
                },
                "mobile_line_data": {
                    "unit": state.Data_Unit,
                    "amount": state.Mobile_Line_Data
                },
                "mobile_line_voice": {
                    "unit": "min",
                    "amount": state.Voice
                }
            },
        }

        try {
            await axios.put(getters.getEndpointFromPath(state.paths.additionalsPath) + state.editingId + '/', additional)
            dispatch('getAdditionals')
            dispatch('ManagementBase/promotionManagement/getTariffDropDown', {}, { root: true })

            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Tarifa añadida correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al añadir tarifa',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}